// Fixed quick-add bar for Battlefield (phone + tablet).
import { Box } from '@mui/material';
import QuickAddFieldWithHint from '@/components/layout/QuickAddFieldWithHint';
import { QUICK_ADD_INPUT_SX } from '@/components/layout/quickAddStyles';

export default function MobileQuickBar() {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        pb: 'max(8px, env(safe-area-inset-bottom))',
      }}
    >
      <Box
        sx={{
          p: '8px 12px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Box sx={{ flex: 1, maxWidth: 480 }}>
          <QuickAddFieldWithHint sx={QUICK_ADD_INPUT_SX} />
        </Box>
      </Box>
    </Box>
  );
}
